import type { IDocument } from "@bbj-types/document";
import type { DocumentTypes } from "@bbj-types/document/enum";
import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axios, axiosInstance } from "./axios";

export interface IFindDocumentsParams {
  ids?: ObjectId[];
  uploaded?: boolean;
  organisation?: string;
  typeDoc?: DocumentTypes[];
}

export const useFindDocuments = () => {
  const [state, execute, cancel] = axios<IDocument[], void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: IFindDocumentsParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useFindDocumentsSuspense = (
  ids?: IFindDocumentsParams["ids"],
  uploaded?: IFindDocumentsParams["uploaded"],
  typeDoc?: DocumentTypes[],
  organisation?: IFindDocumentsParams["organisation"]
) => {
  return useSuspense(
    () =>
      axiosInstance.get<IDocument[]>("", {
        withCredentials: true,
        params: { ids, uploaded, typeDoc, organisation },
      }),
    [ids, uploaded, organisation]
  );
};
